<template>
    <div
        class="o-notifications"
        :class="{'o-notifications--static': isStatic }"
        v-if="notifications.length > 0"
    >
        <transition-group
            name="list"
            mode="in-out"
            tag="article"
        >
            <div
                v-for="(notification, id) in notifications"
                v-bind:key="`notification${id}`"
            >
                <article
                    v-if="name === '' || notification.name === name"
                    class="o-notifications__notification"
                    :class="`o-notifications__notification--${notification.type}`"
                    @click="removeNotification(notification)"
                >
                    <div
                        v-if="notification.title"
                        class="o-notifications__notificationHeader"
                    >
                        <p>
                            {{ notification.title }}
                        </p>
                        <button
                            class="o-notifications__notificationClose"
                            aria-label="delete"
                            @click="removeNotification(notification)"
                        >
                            <a-icon icon="Close" />
                        </button>
                    </div>
                    <div class="o-notifications__notificationBody">
                        <span v-html="notification.content"></span>
                        <button
                            v-if="!notification.title"
                            class="o-notifications__notificationClose o-notifications__notificationClose--inBody"
                            aria-label="delete"
                            @click="removeNotification(notification)"
                        >
                            <a-icon
                                icon="CloseSuccess"
                                v-if="notification.type === 'success'"
                            />
                            <a-icon
                                v-else
                                icon="Close"
                            />
                        </button>
                    </div>
                </article>
            </div>
        </transition-group>
    </div>
</template>

<script>
export default {
    props: {
        isStatic: {
            type: Boolean,
            default: false
        },
        name: {
            type: String,
            default: ''
        }
    },
    computed: {
        notifications() {
            return this.$store.getters.notifications
        }
    },
    methods: {
        removeNotification(notification) {
            this.$store.dispatch('removeNotification', notification.id)
        }
    }
}
</script>